import { useSelector } from 'react-redux';

export const Roundboard = () => {
  const roundOne = useSelector((state) => state.round.roundOne);
  const roundTwo = useSelector((state) => state.round.roundTwo);
  const roundThree = useSelector((state) => state.round.roundThree);
  const roundFour = useSelector((state) => state.round.roundFour);
  const roundFive = useSelector((state) => state.round.roundFive);
  const roundSix = useSelector((state) => state.round.roundSix);
  const roundSeven = useSelector((state) => state.round.roundSeven);

  const classRoundItem = (count) => {
    switch (count) {
      case 0:
        return 'round__item--opacity';
      case 1:
        return 'round__item--green';
      case 2:
        return 'round__item--red';
      case 3:
        return 'round__item--current';
      default:
        return 'round__item--opacity';
    }
  };

  return (
    <div className='round'>
      <div className='round__header'>Осталось раундов</div>
      <div className='round__body'>
        <ul className='round__list'>
          <li className={'round__item ' + classRoundItem(roundOne)}></li>
          <li className={'round__item ' + classRoundItem(roundTwo)}></li>
          <li className={'round__item ' + classRoundItem(roundThree)}></li>
          <li className={'round__item ' + classRoundItem(roundFour)}></li>
          <li className={'round__item ' + classRoundItem(roundFive)}></li>
          <li className={'round__item ' + classRoundItem(roundSix)}></li>
          <li className={'round__item ' + classRoundItem(roundSeven)}></li>
        </ul>
      </div>
    </div>
  );
};
